import { Component, OnInit } from '@angular/core';
import {FormBuilder} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";
import {BsModalService} from "ngx-bootstrap";

@Component({
  selector: 'app-packagers-promotion',
  templateUrl: './packagers-promotion.component.html',
  styleUrls: ['./packagers-promotion.component.scss']
})
export class PackagersPromotionComponent implements OnInit {

  isLoading: any;
  packForm: any;
  packages: any;

  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) { }

  ngOnInit() {
    this.getallPackages();
  }


  getallPackages(){
    this.userService.normalpackagesGetall().subscribe(
      res => {
        if (res.responseCode == 200) {
          this.packages = res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  packageDelete(errorModal: any, id: any) {

  }

  packageUpdate(id: any) {

  }

  createModal() {

  }

  createPackage() {

  }
}
